import React from 'react';

export const TextField = ({ label, name, value, onChange, type = 'text', placeholder }) => (
  <div>
    <label className="label-caps text-[#6b625a] block mb-2">{label}</label>
    <input
      className="field-underline"
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);

export const SelectField = ({ label, name, value, onChange, options, placeholder }) => (
  <div>
    <label className="label-caps text-[#6b625a] block mb-2">{label}</label>
    <select className="select-underline" name={name} value={value} onChange={onChange}>
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export const TextAreaField = ({ label, name, value, onChange, placeholder, rows = 4 }) => (
  <div className="md:col-span-2">
    <label className="label-caps text-[#6b625a] block mb-2">{label}</label>
    <textarea
      className="textarea-underline"
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
    />
  </div>
);
